/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type PdpRespTradeOnApprovalCoachmarkLoader_user$ref = any;
type SharedContactDealerWrapper_user$ref = any;
type TradeOnboardingCoachmarkConditionalLoader_user$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type PdpSharedContactDealerButton_user$ref: FragmentReference;
export type PdpSharedContactDealerButton_user = {|
  +$fragmentRefs: SharedContactDealerWrapper_user$ref & TradeOnboardingCoachmarkConditionalLoader_user$ref & PdpRespTradeOnApprovalCoachmarkLoader_user$ref,
  +$refType: PdpSharedContactDealerButton_user$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "PdpSharedContactDealerButton_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "SharedContactDealerWrapper_user",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "TradeOnboardingCoachmarkConditionalLoader_user",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpRespTradeOnApprovalCoachmarkLoader_user",
      "args": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '601b0173384836cb8249f847605bfd78';
module.exports = node;
